import { motion } from "framer-motion"
import { PropsWithChildren } from "react"
import { useLocation } from "react-router-dom"

import { fadeUp } from "../utils/animations"

export default function RouteAnimation({ children }: PropsWithChildren<{}>) {
  // active route
  const location = useLocation()
  const rootPath = location.pathname.split("/")[1]

  return (
    <motion.main variants={fadeUp} initial="hidden" animate="shown" key={rootPath}>
      {children}
    </motion.main>
  )
}
